import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminApi } from '../../state/admin/api.ts';

const MANAGER_ROLES = new Set(['owner', 'admin', 'manager']);

export function resolveRoleBasedHome(me: {
  user: { id: string } | null;
  is_system_admin: boolean;
  active_company: { id: string; role: string } | null;
}): string {
  if (!me.user) return '/sign-in';
  if (me.is_system_admin) return '/admin';
  if (me.active_company && MANAGER_ROLES.has(me.active_company.role)) {
    return `/company/${me.active_company.id}/dashboard`;
  }
  return '/dashboard';
}

export function RoleBasedRedirect(): React.JSX.Element | null {
  const navigate = useNavigate();

  useEffect(() => {
    void (async () => {
      const res = await adminApi.whoami();
      if (!res.ok || !res.data.user) {
        navigate('/sign-in', { replace: true });
        return;
      }
      navigate(resolveRoleBasedHome(res.data), { replace: true });
    })();
  }, [navigate]);

  return <p className="font-mono text-mono text-muted-2">redirecting…</p>;
}
